import {Component} from 'react'

class ProductCard extends Component {
  render() {
    const {product, onClick} = this.props

    let statusColor = ''

    switch (product.status) {
      case 'In Stock':
        statusColor = 'in-stock'
        break
      case 'Limited Stock':
        statusColor = 'limited'
        break
      default:
        statusColor = 'out-stock'
        break
    }
    return (
      <button type="button" className="card" onClick={onClick}>
        <img
          src={product.imageUrl}
          alt={product.name}
          className="product-image"
        />

        <h2>{product.name}</h2>
        <p>{product.category}</p>
        <p className="producer">{product.producer}</p>
        <h4 className={`badge ${statusColor}`}>Status :{product.status}</h4>
      </button>
    )
  }
}

export default ProductCard
